import React, { useState } from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Button,
  Tag,
  Card,
  CardBody,
  Image,
  IconButton,
  useColorModeValue,
  Link
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { Search, Star, Plus, Settings } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import Sidebar from '../../components/Dashboard/Sidebar';



// Featured dataset card component
const DatasetCard = ({ title, description, image, url }) => {
  return (
    <Card
      onClick={()=>{
        window.open(url);
      }}
      overflow="hidden"
      variant="outline"
      borderRadius="lg"
      boxShadow="sm"
      transition="transform 0.3s, box-shadow 0.3s"
      _hover={{
        transform: 'translateY(-5px)',
        boxShadow: 'md',
        cursor: 'pointer'
      }}

    >
      <Image
        src={`/images/${image}`}
        alt={title}
        height="200px"
        objectFit="cover"
      />
      <CardBody p={4}>
        <Flex justify="space-between" align="center" mb={2}>
          <Heading size="md" noOfLines={1}>{title}</Heading>
          <IconButton
            aria-label="Options"
            icon={<Settings size={16} />}
            variant="ghost"
            size="sm"
          />
        </Flex>
        <Text fontSize="sm" noOfLines={2} mb={3} color="gray.600">
          {description}
        </Text>
      </CardBody>

    </Card>
  );
};

const Dashboard = () => {
  const [activeCategory, setActiveCategory] = useState('All datasets');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const { user } = useAuth()

  const categories = [
    'All datasets',
    'Surahs',
    'Juz',
    'Tafseer',
    'Recitations',
    'Translations'
  ];

  const featuredDatasets = [
    {
      title: 'Resources',
      description: 'Expert-endorsed datasets, documents, recitations and links',
      image: 'dataset.png',
      url : '/resources'
    },
    {
      title: 'Models',
      description: 'View existing Quranic AI models',
      image: 'model.png',
      url : '/models'
    }
  ];

  return (
    <Flex direction="row" h="100vh">
      {/* Collapsible Sidebar Component */}
      <Sidebar isCollapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <Box
        pl={sidebarCollapsed ? "60px" : "250px"}
        w="full"
        overflowY="auto"
        pb={8}
        transition="padding-left 0.2s ease"
      >
        <Box p={8}>
          <Flex direction="column" mb={8}>
            {/* Header Area */}
            <Flex justify="space-between" mb={4}>
              <Box>
                {/* <pre>{JSON.stringify(user)}</pre> */}
                <Heading size="xl" mb={2}>Respected expert : {user?.userId}!</Heading>
                <Text color="gray.600">
                  Let's verify some datasets today !
                </Text>
              </Box>
            </Flex>
          </Flex>


          {/* Featured Datasets */}
          <Box mb={10}>
            <Flex justify="space-between" align="center" mb={4}>
              <Flex align="center">
                <Star size={20} fill="currentColor" color="gray.600" />
                <Heading size="lg" ml={2}>Our Features</Heading>
              </Flex>
            </Flex>
            <Text mb={6} color="gray.600">
              Browse on our features as Quranic Datahub
            </Text>

          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default Dashboard;